
import moment from 'moment';
import { Button } from 'primereact/button';
import React, { useContext, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import count_days from '../../functions/count_days';
import sum_total_paid from '../../functions/sum_total_paid';
import sum_total_price from '../../functions/sum_total_price';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';

import { RESORT_NAME_AR, RESORT_NAME_EN } from '../../Helper/user';
import FooterInvoice from './FooterInvoice';
import HeaderInvoice from './HeaderInvoice';
import { InvoiceContext } from './Invoice_Context';
import './invoice.css';
import { view_Apartment } from '../../constants/dataView';

function InvoiceBookinges() {
    const data = useContext(InvoiceContext)
    const componentRef = useRef();
    const buttonRef = useRef();
    // eslint-disable-next-line no-unused-vars
    const [isShown, setIsShown] = useState(false);
    var monthView = 0;
    const datasort = [...data].sort((a, b) =>
        a.date_check_in > b.date_check_in ? 1 : -1,
    );

    return (
        <div>
            <div id="invoice" className="page page-content fade-in-up" dir="rtl" style={{ margin: "auto", maxWidth: "850PX" }} ref={componentRef}>
                <div className="ibox invoice-print" >
                    <div className="invoice-header">
                        <div className="row">
                            <div className="col-12">
                                <HeaderInvoice ></HeaderInvoice>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table className="table table-bordered table-striped no-margin table-invoice">
                            <tbody style={{ fontSize: "13px" }}>
                                <tr className="color-view bg-white ">
                                    <td colSpan={3} >
                                        <center>
                                            <strong >
                                                عدد الحجوزات :  {datasort.length}
                                            </strong>
                                        </center>
                                    </td>
                                    <td colSpan={3} >
                                        <center>
                                            <strong >
                                                إجمالي الأيام : {count_days(datasort)}
                                            </strong>
                                        </center>
                                    </td>
                                </tr>
                                {
                                    datasort.map((res) => {
                                        return (
                                            <>
                                                {
                                                    monthView !== moment(res.date_check_in).format('MM') ?
                                                        (
                                                            <>


                                                                <tr className="color-view bg-white ">
                                                                    <td colSpan={12} >
                                                                        <center>
                                                                            <strong >
                                                                                {" حجوزات شهر "}
                                                                                {monthView = moment(res.date_check_in).format('MM')}
                                                                                {" " + moment(res.date_check_in).format('MMMM') + " "}
                                                                            </strong>
                                                                        </center>
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ fontSize: "10px" }}>
                                                                    <th>الحجز</th>
                                                                    <th> الزبون</th>
                                                                    <th style={{ width: "10%" }} > الإقامة </th>
                                                                    <th colSpan={2} style={{ textAlign: "center", width: "30%" }} >
                                                                        الدخول - المغادرة
                                                                    </th>
                                                                    <th>الأيام</th>
                                                                    <th>السعر</th>
                                                                    <th>الإجمالي</th>
                                                                    <th>المدفوع</th>
                                                                    <th>الباقي</th>
                                                                    <th>التخفيض</th>
                                                                    {/* <th style={{textAlign:"center",width:"10%"}}>تاريخ  إلغاء </th> */}
                                                                    {/* <th>ملاحظات</th> */}
                                                                </tr>
                                                            </>
                                                        )
                                                        :
                                                        (null)
                                                }

                                                <tr>
                                                    <td>
                                                        {res.ID_reservation}
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <strong >{res.visitor_name}</strong>
                                                        </div>
                                                        <small>{res.phone_number}</small>
                                                    </td>
                                                    <td>
                                                        {view_Apartment(res)}
                                                    </td>
                                                    {
                                                        res.reservation_type === 'service' ?
                                                            <td colSpan={2} >
                                                                <center>
                                                                    <div>
                                                                        <strong >{res.date_check_in} </strong>
                                                                    </div>
                                                                    <small> {view_day_ar(res.date_check_in)} </small>{res.services_names}
                                                                </center>
                                                            </td>
                                                            :
                                                            <>
                                                                <td  >
                                                                    <div>
                                                                        <strong >{res.date_check_in} </strong>
                                                                    </div>
                                                                    <small> {view_day_ar(res.date_check_in)} </small>
                                                                </td>
                                                                <td >
                                                                    <div>
                                                                        <strong>{res.date_check_out}  </strong>
                                                                    </div>
                                                                    <small>  {view_day_ar(res.date_check_out)} </small>
                                                                </td>
                                                            </>
                                                    }
                                                    <td style={{ width: "5%" }}>{count_days([res])} أيام</td>
                                                    <td>{res.price_day}  د.ل</td>
                                                    <td><strong >{res.total_price} د.ل</strong></td>
                                                    <td><strong >{res.total_paid} د.ل</strong></td>
                                                    <td>
                                                        {
                                                            res.total_price - res.total_paid === 0 ?
                                                                (
                                                                    <strong style={{ color: "green" }}>
                                                                        خالص
                                                                    </strong>
                                                                )
                                                                :
                                                                (
                                                                    <strong style={{ color: "red" }}>
                                                                        {res.total_price - res.total_paid} د.ل
                                                                    </strong>
                                                                )
                                                        }
                                                    </td>
                                                    <td><strong >{res.discount_value === 0 ? '-' : res.discount_value + 'د.ل'}</strong></td>
                                                    {/* <td >
                                            {
                                                res.date_del_reservation?
                                                <strong style={{color:"red"}}>
                                                    {moment(res.date_del_reservation).format('MM-DD')}
                                                    <br></br>
                                                    {moment(res.date_del_reservation).format('LT')}
                                                </strong>
                                                :"-"
                                            }
                                        </td> */}
                                                    {/* <td><strong >{res.notes}</strong></td> */}

                                                </tr>

                                            </>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <table className="table no-border">
                        <thead>

                            {
                                data.return_amount ?
                                    (
                                        <tr className="text-center" >
                                            <td className="font-bold font-15 text-left" > القيمة المسترجعة </td>
                                            <td className="font-bold font-15 text-right" style={{ color: "red" }} >
                                                <strong style={{ color: "red" }} dir='ltr' >
                                                    {data.return_amount}
                                                </strong> د.ل
                                            </td>
                                        </tr>
                                    )
                                    :
                                    (null)
                            }
                            <tr>
                                <td className="font-bold font-18 text-center">إجمالي المبلغ  </td>
                                <td className="font-bold font-18 text-center">إجمالي المدفوع  </td>
                                <td className="font-bold font-18 text-center">إجمالي المتبقي  </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>{sum_total_price(data)}
                                    د.ل</td>
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>{sum_total_paid(data)} د.ل</td>
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>
                                    {
                                        sum_total_price(data) - sum_total_paid(data) === 0 ?
                                            (
                                                <strong style={{ color: "green" }}>
                                                    خالص
                                                </strong>
                                            )
                                            :
                                            (
                                                <strong style={{ color: "red" }}>
                                                    {sum_total_price(data) - sum_total_paid(data)} د.ل
                                                </strong>
                                            )
                                    }
                                </td>
                            </tr>
                            <br></br>
                            <tr>
                                <th className="font-bold font-18 text-center" colSpan={10}>
                                    <center>
                                        نتمنى لكم قضاء صيف رائع في {RESORT_NAME_AR} - {RESORT_NAME_EN}
                                    </center>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <FooterInvoice></FooterInvoice>
            </div>

            <div className="text-center">
                <ReactToPrint
                    trigger={
                        () => <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-print' outlined
                            ref={buttonRef} onClick={() => setIsShown(current => !current)}
                        />
                    }
                    content={() => componentRef.current}
                />
            </div>
        </div>
    );
}
export default InvoiceBookinges;